import { Pipe, PipeTransform } from '@angular/core';
import { DecimalPipe } from '@angular/common';

@Pipe({
  name: 'trimNumber',
  standalone: true,
})
export class TrimNumber implements PipeTransform {
  constructor(private decimalPipe: DecimalPipe) {}
  transform(number: any, digits?: any): unknown {
    let isNegativeNumber = number < 0;
    let numberWithoutNegative = isNegativeNumber ? number * -1 : number;
    // hundreds
    if (numberWithoutNegative <= 999) {
      return isNegativeNumber ? -number : number;
    }
    // thousands
    else if (numberWithoutNegative >= 1000 && numberWithoutNegative <= 999999) {
      return (
        this.decimalPipe.transform(
          (isNegativeNumber ? -numberWithoutNegative : number) / 1000,
          digits
        ) + 'K'
      );
    }
    // millions
    else if (numberWithoutNegative >= 1000000 && numberWithoutNegative <= 999999999) {
      return (
        this.decimalPipe.transform(
          (isNegativeNumber ? -numberWithoutNegative : number) / 1000000,
          digits
        ) + 'M'
      );
    }
    // billions
    else if (numberWithoutNegative >= 1000000000 && numberWithoutNegative <= 999999999999) {
      return (
        this.decimalPipe.transform(
          (isNegativeNumber ? -numberWithoutNegative : number) / 1000000000,
          digits
        ) + 'B'
      );
    }
    // Trillions
    else if (numberWithoutNegative >= 1000000000000) {
      return (
        this.decimalPipe.transform(
          (isNegativeNumber ? -numberWithoutNegative : number) / 1000000000000,
          digits
        ) + 'T'
      );
    } else return number;
  }
}
